import React from "react";
import {
  MyTable,
  MyTableBody,
  MyTableHead,
  MyTableTR,
  VerticalMain,
} from "../../style/default";
import { LineSkeleton } from "./styles";

function Skeleton(props) {
  return (
    <>
      <VerticalMain>
        <MyTable responsive>
          <MyTableHead>
            <MyTableTR>
              {props.data ? (
                props.data.map((item, i) => <th key={i}>{item}</th>)
              ) : (
                <>
                  <th>Carregando</th>
                  <th>Quase Lá</th>
                  <th>Aguarde</th>
                  <th>Um momento</th>
                  <th>Chegando Perto</th>
                  <th>Acabando</th>
                </>
              )}
            </MyTableTR>
          </MyTableHead>
          <MyTableBody>
            {props.data &&
              props.data.map((_, i) => (
                <MyTableTR key={i}>
                  {props.data.map((_, j) => (
                    <LineSkeleton key={j}>
                      <span></span>
                    </LineSkeleton>
                  ))}
                </MyTableTR>
              ))}
          </MyTableBody>
        </MyTable>
      </VerticalMain>
    </>
  );
}

export { Skeleton };
